import React, { useState } from 'react';
import { useSetting } from '../../../util/useSetting';
import PreviousSvg from '../../../svg/student/Previous.js';
import NextSvg from '../../../svg/student/Next.js';
import ReloadSvg from '../../../svg/student/Reload.js';
import { connect } from 'react-redux';
import SliderPage from './SliderPage';

const DATA = {
    name: '香港學生睡眠',
    tabs: [
        {
            name:'報章評論',
            url:'https://www.news.com/article1',
            contents:[
                {
                    type:'image',
                    src:'/secondary/tasks/rp4.png',
                },
                {
                    type:'html',
                    html:'<br/><br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;每天早上，總有一些學生拖著書包、沒精打采地走進校門，甚至上完第一節課後仍然十分困倦。這幅常見景象，令「是否該把早會或第一節課延後」再次成為教育界爭議。這個建議並非毫無道理，但延後二十分鐘能否解決睡眠不足，卻不宜過早下定論。<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;香港已有學校開始嘗試調整時間。以明智中學為例，學校留意到部分學生在早上首兩節課精神不集中，因此計劃在下學期試行新的時間安排，把早會由上午8時延至8時20分，並相應調整第一節課、午膳和放學時間。<br/><br/>'
                },
                {
                    type:'title',
                    text:'試行安排時間表'
                },
                {
                    type:'html',
                    html:`
                    <table class='w-full' style='border: 1px solid #9CB8D3;'>
  <tr>
    <th class='text-center' style='background-color: #EDF5F8; border: 1px solid #9CB8D3;'>項目</th>
    <th class='text-center' style='background-color: #EDF5F8; border: 1px solid #9CB8D3;'>現行時間</th>
    <th class='text-center' style='background-color: #EDF5F8; border: 1px solid #9CB8D3;'>試行時間</th>
  </tr>
  <tr>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>校門開放</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>上午7:45</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>上午7:45</td>
  </tr>
  <tr>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>早會</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>上午8:00</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>上午8:20</td>
  </tr>
  <tr>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>第一節課</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>上午8:40</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>上午9:00</td>
  </tr>
  <tr>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>午膳</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>下午12:40</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>下午1:10</td>
  </tr>
  <tr>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>放學</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>下午4:00</td>
    <td class='text-center'style='border: 1px solid #9CB8D3;'>下午4:20</td>
  </tr>
</table>                    `
                },
                {
                    type:'html',
                    html:'<br/><br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;此外，明智中學還計劃在試行期間收集教師的課堂觀察紀錄和學生問卷，並舉辦介紹睡眠與學業表現的家長講座。這些措施是良好的嘗試，但是否真的有幫助，仍要根據試行後學生的課堂專注度以及整體狀態來判斷。如果效果不明顯，學校也應重新檢視時間安排是否切合學生的實際需要。不同學校的校情、學生居住地點、交通和午膳安排不盡相同，也不宜立刻要求所有學校實行。<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;更重要的是，社會和學校不應把延後早間課堂看成解決學生睡眠問題的簡單答案。真正值得關注的，不是早會究竟延後多少分鐘，而是學生能否實現更充足和規律的作息，並在課堂保持較好的精神狀態。<br/><br/><br/><br/><br/>'
                }
            ]
        }
    ],
    questions: [
        {
            type: 'display-text',
            html: '最近，你和同學子晴上早課時總是提不起精神，還不時打呵欠。一天小息時，你們在社交平台看到一篇討論學校應否延後早會或第一節課的報章評論，便好奇地點進去閱讀。<br/><br/>點擊「下一頁」的箭號來閱讀第一個來源。'
        },
        {   
            id:'1',
            type: '選擇題',
            question: '1. 根據報章評論中的描述，以下哪項最能概括明智中學校方的處理方式？',
            subtitle: '參考左側的「報章評論」，點擊一個選項來回答本題。',
            options: [
                { text: 'A. 縮短在校時間，觀察學生睡眠變化' },
                { text: 'B. 調整上課時間，配合講座及成效檢視' },
                { text: 'C. 舉辦家長講座，再決定是否調整時間' },
                { text: 'D. 依靠教師觀察，暫不收集學生意見' }
            ],
            tab:0,
        },
        {
            type: '拖放式問題'
        }
    ]
}

function Task(props) {
    const { fontSize } = useSetting();
    const [data, setData] = useState(DATA)
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const handlePrevious = () => {
        let prevIndex = currentQuestionIndex - 1;
        if (prevIndex >= 0) {
            setCurrentQuestionIndex(prevIndex);
        }
    }
    const handleNext = () => {
        let nextIndex = currentQuestionIndex + 1;
        if (nextIndex < data.questions.length) {
            setCurrentQuestionIndex(nextIndex);
        }
    }
    const [tab, setTab] = useState(0);

    return (
        <div className='w-full flex flex-col h-full' style={{ fontSize }}>

            <div className='w-full flex flex-row justify-start gap-[8px] mt-[16px] px-[16px] font-[900]'>
                <button className='px-[18px] py-[4px] rounded-full flex flex-row items-center text-[white] gap-[8px] noto-san-hk font-[600]' style={{ background: 'linear-gradient(to right, #34778C, #63BBD1)' }}>
                    <img src='/secondary/setting.png' alt='設定' />
                    設定
                </button>
                <div className='flex flex-row gap-[8px] flex-1 justify-end'>
                    <button>
                        <img src='/secondary/btn1.png' />
                    </button>
                    <button onClick={handlePrevious}>
                        <img src='/secondary/btn2.png' />
                    </button>
                    <button onClick={handleNext}>
                        <img src='/secondary/btn3.png' />
                    </button>
                </div>


            </div>

            <div className='w-full flex flex-col items-center justify-center flex-1 overflow-auto noto-san-hk mt-[12px]'>

                {data?.questions[currentQuestionIndex]?.type === 'display-text' ? (
                    <div className='flex-1 flex flex-col w-full justify-center items-center'>
                        <div className='w-full text-white font-bold flex flex-col text-left px-[24px] py-[8px]' style={{ background: 'linear-gradient(to right, #55A8E0, #1C7595, #3B77A4)' }}>
                            {data?.name}<br />簡介
                        </div>
                        <div className='flex-1 w-full flex justify-center items-center'>
                            <div className='text-[#003A57] w-full max-w-[800px] text-left flex justify-center items-center' style={{ border: '1px solid #E3E3E3', padding: '64px' }}>
                                <div className='w-full max-w-[400px]' dangerouslySetInnerHTML={{ __html: data?.questions[currentQuestionIndex]?.html }} />
                            </div>
                        </div>
                    </div>
                ) : (
                    <SliderPage initalWidth={35}
                        leftComponent={<LeftComponent data={data} currentQuestionIndex={currentQuestionIndex} setData={setData} />}
                        rightComponent={<RightComponent data={data} currentQuestionIndex={currentQuestionIndex} setData={setData} tab={tab} setTab={setTab} />} 
                    />
                )}
            </div>

        </div>
    )
}


function LeftComponent(props) {
    const data = props.data;
    const { fontSize } = useSetting();
    return <div className='flex flex-col w-full'>
        <div className='flex-1 flex flex-col w-full justify-center items-center'>
            <div className='w-full text-white font-bold flex flex-col text-left px-[24px] py-[8px]' style={{ background: 'linear-gradient(to right, #55A8E0, #1C7595, #3B77A4)' }}>
                {data?.name}<br />簡介
            </div>
        </div>
        {data?.questions[props.currentQuestionIndex]?.type === '選擇題' && (
            <div className='flex-1 w-full flex flex-col justify-start items-start p-[16px] gap-[16px]'>
                <div className='text-[#082037] font-[300]' style={{ fontSize: fontSize - 2 }}>{data?.questions[props.currentQuestionIndex]?.subtitle}</div>
                <div className='text-[#082037] font-[900]' style={{ fontSize: fontSize }}>{data?.questions[props.currentQuestionIndex]?.question}</div>
                <div className='w-full flex flex-col gap-[16px]'>
                        {data?.questions[props.currentQuestionIndex]?.options.map((option, oi) =>
                            <div key={oi} className='w-full text-[black] flex flex-row items-center gap-[16px] font-[400]'>
                                <button className='w-[20px] h-[20px] border border-[#005B8C] rounded-full flex-shrink-0' style={{ backgroundColor: option.selected ? '#005B8C' : 'transparent' }} onClick={
                                    () => {
                                        let newData = { ...data }
                                        for (let op of data?.questions[props.currentQuestionIndex].options) {
                                            op.selected = false
                                        }
                                        newData.questions[props.currentQuestionIndex].options[oi].selected = true
                                        props.setData(newData)
                                    }
                                }>

                                </button>
                                {option.text}
                            </div>
                        )}
                    </div>
            </div>
        )}

    </div>;
}
function RightComponent(props) {
    const { fontSize } = useSetting();
    return <div className='flex flex-col w-full'>

        <div className='w-full flex flex-row justify-start gap-[8px] px-[16px] font-[900]'>
            {props.data?.tabs?.map((tab, ti) => (
                <button
                key={ti}
                className='flex-1 max-w-[220px] overflow-hidden text-ellipsis whitespace-nowrap text-center py-[4px]'
                style={true ? { background: 'linear-gradient(to left, #108B96, #003A57)', color: 'white', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' } : { background: 'linear-gradient(to bottom, #ccc, #fff)', color: '#003A57', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}
                onClick={() => { }}
            >
                {tab.name}
                </button>
            ))}
        </div>
        <div className='w-full flex flex-row bg-[white] items-center' style={{ borderBottom: '1px solid #E3E3E3', marginTop: 4, gap: 6, padding: 6 }}>
            <div className='cursor-pointer'>
                <PreviousSvg height={30} width={30} />
            </div>
            <div className='cursor-pointer'>
                <NextSvg height={30} width={30} />
            </div>
            <div className='cursor-pointer'>
                <ReloadSvg height={30} width={30} />
            </div>
            <div className='flex-1'>
                <input disabled={true} className='w-full text-[black] bg-[#EEF2F6] rounded-[4px]' value={'https://task1.com'} style={{ fontSize: fontSize - 4, height: 40, paddingLeft: 24, paddingRight: 24 }} />
            </div>
        </div>
        <div className='w-full flex flex-col overflow-auto flex-1 gap-[16px] bg-white'>
            {props.tab!==undefined && props.data?.tabs?.[props.tab]?.contents?.map((content, ci) => (
                <div key={ci}>
                    {content.type==='image' 
                    ? <img src={content.src} alt='' />
                    :content.type==='html'
                    ? <div className='px-[16px]' dangerouslySetInnerHTML={{ __html: content.html }} />
                    :content.type==='title'
                    ? <div className='w-full px-[16px] text-center' style={{fontSize: fontSize+2, fontWeight: 'bold'}}>{content.text}</div>
                    : null
                }
                </div>
            ))}

        </div>
    </div>;
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Task)
